import {Params} from '../types';

/**
 * Otestuje, zda existují parametry.

 *
 * @param params - Parametry.
 * @returns Zda existují parametry.
 * @ignore
 */
export default function hasParams(params: Params | undefined): boolean {
    return params != null && Object.keys(params).length > 0;
}
